import ErrorPage from "components/General-UI/ErrorPage";
import Spinner from "components/General-UI/Spinner";
import Avatar from "components/Home/ui/Avatar";
import React, { useCallback, useEffect, useState } from "react";
import PeopleItem from "../PeopleItem/PeopleItem";

const PeopleList = ({
  currentSpace,
  permissionsEffice,
  people,
  fetch,
  type,
  currentUserId,
  meAdmin = null,
  peopleMedia = null,
  membersMuted = null,
  membersShoutable = null,
  available = false,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  let pplAvailable = people && people.length;

  const fetchData = useCallback(
    async (more = false) => {
      setLoaded(false);
      try {
        await fetch(more);
      } catch (error) {
        setError(error);
      }
      setLoaded(true);
    },
    [fetch]
  );

  useEffect(() => {
    setLoaded(true);
    if (people === null) {
      fetchData();
    }
    return () => {
      setLoaded(true);
    };
  }, [people, fetchData]);

  const renderedItems = () => {
    if (people === null || people === undefined) return;
    let items = [];
    people.forEach((person) => {
      items.push(
        <PeopleItem
          key={person.member_id}
          type={type}
          currentSpace={currentSpace}
          user_id={person.id}
          customStyle={{ width: "215px" }}
          avatar={
            <div className={`Txt-avatar d-inline-block`}>
              <Avatar
                avatar_key={person.avatar_key}
                given_name={person.given_name}
                family_name={person.family_name}
              />
            </div>
          }
          given_name={person.given_name}
          family_name={person.family_name}
          other_role_id={person.role_id}
          permissionsEffice={permissionsEffice}
          meAdmin={meAdmin}
          currentUserId={currentUserId}
          peopleMedia={peopleMedia}
          membersMuted={membersMuted}
          membersShoutable={membersShoutable}
        />
      );
    });
    return items;
  };
  return (
    <div className={`people-list`}>
      {error ? <ErrorPage /> : <>{pplAvailable > 0 && renderedItems()}</>}
      {loaded ? null : <Spinner notFullHeight={true} />}
      {available && loaded && !error ? (
        <button className="more-button" onClick={() => fetchData(true)}>
          More...
        </button>
      ) : null}
    </div>
  );
};

export default PeopleList;
